import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticatedPageComponent } from 'src/app/components/base.component';
import { MainpageComponent } from 'src/app/components/mainpage/mainpage.component';
import { AuthService } from 'src/app/services/auth.service';
import { UIStateService } from 'src/app/services/ui-state.service';
import { Shop } from 'src/app/dto';
import { ShopService } from 'src/app/services/shop.service';

@Component({
    selector: 'app-shops-manager',
    templateUrl: './shops-manager.component.html',
    styleUrls: ['./shops-manager.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShopsManagerComponent extends AuthenticatedPageComponent implements OnInit {
    public static route = 'shopsmanager';

    // Backed by a signal, not a plain field - every write below happens inside an async
    // subscribe, never a template-bound handler (addNewShop()/deleteShop() are click-triggered,
    // but the push()/splice() below run inside that click's HTTP response, after the click's own
    // OnPush check already ran). equal: () => false because addNewShop()/deleteShop() mutate the
    // held array in place (push/splice) rather than replacing it, so every .set() - even of the
    // same reference - must be treated as a change. The getter keeps every shop.X read/
    // [(ngModel)] site working unchanged.
    private shopsState = signal<Shop[]>([], { equal: () => false });
    get shops(): Shop[] { return this.shopsState(); }
    private formShopState = signal<Shop>(new Shop(null));
    get formShop(): Shop { return this.formShopState(); }

    constructor(private shopService: ShopService, private modalService: NgbModal, router: Router, authService: AuthService, uiStateService: UIStateService) {
        super(router, authService, MainpageComponent.route, uiStateService);
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.shopService.activeUserShops.subscribe(s => {
                s.sort((a, b) => a.Id - b.Id);
                this.shopsState.set(s);
            }));
    }

    public updateShop(shop: Shop): void {
        this.subscriptions.push(this.shopService.updateShops(shop).subscribe());
    }

    public updateAllShops(): void {
        this.shops.forEach(s => {
            this.subscriptions.push(
                this.shopService.updateShops(s).subscribe()
            );
        });
    }

    public addNewShop(formShop: Shop): void {
        this.subscriptions.push(
            this.shopService.addShop(formShop).subscribe(s => {
                this.shops.push(s);
                this.shopsState.set(this.shops); // re-notify - same reference, equal: () => false forces it through
                this.formShopState.set(new Shop(null));
            })
        );

    }

    public deleteShop(shop: Shop): void {
        this.subscriptions.push(
            this.shopService.removeShop(shop).subscribe(() => {
                const indexToRemove = this.shops.findIndex(s => shop.Id === s.Id);
                if (indexToRemove !== -1) {
                    this.shops.splice(indexToRemove, 1);
                    this.shopsState.set(this.shops); // re-notify - same reference, equal: () => false forces it through
                }
                this.modalService.dismissAll();
            })
        );

    }

    openModal(content: any) {
        this.modalService.open(content);
    }

    closeModal() {
        this.modalService.dismissAll();
    }



}
